import React from 'react'
import { useGLTF } from '@react-three/drei'

export function UsPlusSkin(pos) {
  const { nodes, materials } = useGLTF('/models/processor2-transformed.glb')
  return (
    <group position={[pos[0], pos[1], pos[2] - 0.8]} dispose={null} rotation={[0, Math.PI / 2, 0]}>
      <mesh geometry={nodes['20250604_EPCB0015-V02004'].geometry} material={materials.PaletteMaterial002} />
      <mesh geometry={nodes['20250604_EPCB0015-V02004_1'].geometry} material={materials.PaletteMaterial001} />
    </group>
  )
}

useGLTF.preload('/models/processor2-transformed.glb')
